export const getEnvVar = (key: string): string => {
  const value = import.meta.env[key];
  if (!value) throw Error(`missing env variable ${key}`);
  return value;
};
